"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import "../styles/Register.css"

function Register() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    password: "",
    companyName: "",
    isAgency: true,
  })
  const [isFormValid, setIsFormValid] = useState(false)

  const handleChange = (e) => {
    const { name, value, type } = e.target

    const newFormData = {
      ...formData,
      [name]: type === "radio" ? value === "yes" : value,
    }

    setFormData(newFormData)

    // Validate required fields
    const requiredFields = ["fullName", "phoneNumber", "email", "password"]
    const isValid = requiredFields.every((field) => newFormData[field].trim() !== "")
    setIsFormValid(isValid)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isFormValid) {
      // In a real app, you would handle registration here
      navigate("/account")
    }
  }

  return (
    <div className="register-container">
      <div className="register-header">
        <h1>Create your</h1>
         <h1>PopX account</h1>
      </div>

      <form className="register-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="fullName">
            Full Name<span className="required">*</span>
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="Marry Doe"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">
            Phone number<span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            placeholder="Marry Doe"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">
            Email address<span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Marry Doe"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">
            Password<span className="required">*</span>
          </label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Marry Doe"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="companyName">Company name</label>
          <input
            type="text"
            id="companyName"
            name="companyName"
            placeholder="Marry Doe"
            value={formData.companyName}
            onChange={handleChange}
          />
        </div>

        <div className="form-group radio-group">
          <label className="radio-label">
            Are you an Agency?<span className="required">*</span>
          </label>
          <div className="radio-options">
            <label className="radio-container">
              <input
                type="radio"
                name="isAgency"
                value="yes"
                checked={formData.isAgency === true}
                onChange={handleChange}
              />
              <span className="radio-custom"></span>
              <span className="radio-text">Yes</span>
            </label>

            <label className="radio-container">
              <input
                type="radio"
                name="isAgency"
                value="no"
                checked={formData.isAgency === false}
                onChange={handleChange}
              />
              <span className="radio-custom"></span>
              <span className="radio-text">No</span>
            </label>
          </div>
        </div>

        <button type="submit" className={`register-button ${isFormValid ? "active" : ""}`} disabled={!isFormValid}>
          Create Account
        </button>
      </form>
    </div>
  )
}

export default Register

